// (function () {
//     // Check if the module exists before doing anything
//     const {{module_name_camel}}Exists = !!document.querySelector('.upcoming-events');

//     // If the module exists, do whatever we need to
//     if ({{module_name_camel}}Exists) {
//         // Your code here
//     }

// })();

const upcomingEventElementList = document.querySelectorAll(".upcoming-events");

if (upcomingEventElementList.length !== 0) {
    for (let x = 0; x < upcomingEventElementList.length; x++) {
        const hasResults = upcomingEventElementList[x].querySelector(".no-results-found");

        if (hasResults) {
            upcomingEventElementList[x].style.display = "none";
        }
    }
}